import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */

/* 

//获取视频推荐
export const findVideoRecommand = (clID) => {
  return request('/video/recommend', 'get', { clID })
} */

//获取video视频
export const findBooks = ({ maID, chID, coID, clID, page, size }) => {
  return request('/books/bookslist', 'get', { maID, chID, coID, clID, page, size })
}

//获取课程详情
export const findbooksDetail = (id) => {
  return request('/books/detail', 'get', { id })
}

//获取确认订单详情
export const findBooksCheckOut = (id) => {
  return request('/books/checkout', 'get', { id })
}
/* export const findVideoPlay = (id) => {
  return request('/video/play', 'get', { id })
} */